export default __webpack_public_path__ + "static/media/2.3f8b1f74.jpg";